import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import DataTable from "react-data-table-component";
import AdminNavbar from "../components/AdminNavbar";
import { motion } from "framer-motion";

function Dashboard() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) {
          navigate("/login");
          return;
        }
        const response = await axios.get("/admin/getUsers", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(response.data.users);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch users.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [navigate]);

  const deleteUser = async (userId) => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.delete(`/admin/deleteUser/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage(response.data.message);
      setUsers(users.filter((user) => user.id !== userId));
    } catch (err) {
      setError(err.response?.data?.message || "Failed to delete user.");
    }
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Country",
      selector: (row) => row.country,
      sortable: true,
    },
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-grid gap-2">
          <div className="dropdown">
            <button
              className="btn btn-info btn-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              View
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/userTransactions/${row.id}`, {
                      state: { userName: row.name },
                    })
                  }
                >
                  Accounts
                </button>
              </li>
              <li>
                <button
                  className="dropdown-item"
                  onClick={() =>
                    navigate(`/userOperations/${row.id}`, {
                      state: { userName: row.name },
                    })
                  }
                >
                  Operation
                </button>
              </li>
            </ul>
          </div>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => deleteUser(row.id)}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <AdminNavbar />
      <div className="container mt-5">
        <motion.h1
          className="mb-4 text-center"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 120 }}
        >
          Admin Dashboard
        </motion.h1>

        {error && (
          <motion.div
            className="alert alert-danger"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {error}
          </motion.div>
        )}

        {message && (
          <motion.div
            className="alert alert-success"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {message}
          </motion.div>
        )}

        <motion.div
          className="table-container mt-3"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <DataTable
            title="User List"
            columns={columns}
            data={users}
            pagination
            progressPending={loading}
            highlightOnHover
            responsive
          />
        </motion.div>
      </div>
    </motion.div>
  );
}

export default Dashboard;
